<template>
  <v-tooltip color="appMain" top :disabled="!showTooltip">
    <template v-slot:activator="{ on }">
      <div
        ref="participantInfo"
        class="participant-info text-ellipsis"
        v-on="on"
        v-resize="isInfoOverflow"
      >
        {{ participantInfo }}
      </div>
    </template>
    <div>
      {{ participantInfo }}
    </div>
  </v-tooltip>
</template>

<script>
import { isTextOverflow } from '@/filters/helpers';

export default {
  name: 'ParticipantInfo',
  props: {
    participantInfo: String,
    isVisible: Boolean,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  methods: {
    async isInfoOverflow() {
      await this.$nextTick();

      const el = this.$refs.participantInfo;
      if (!el || !this.isVisible) return;
      this.showTooltip = isTextOverflow(el);
    },
  },
  mounted() {
    this.isInfoOverflow();
  },
};
</script>

<style lang="less">
.participant-info {
  opacity: 0.8;
  font-size: 12px;
  line-height: 16px;
  font-style: italic;
  padding: 0;
}
</style>
